import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import React from "react";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import Button from "../button/button";
import "./content-description.scss";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
const blockquoteOpen = require("../../../assets/images/icons/ComillasWhiteClose.svg");
const blockquoteClose = require("../../../assets/images/icons/ComillasWhiteOpen.svg");
const ContentDescription = (props: ReferenciaContenido) => {
  //console.log(props);

  return (
    <div
      className={`a-content-description ${
        props.titulo.split(">")[0] === "Empresas red de amor "
          ? "enterprises"
          : ""
      }`}
    >
      <div className="a-content-description-container">
        {props.nombreCategoria !== "Empresas" ? (
          <img
            className="a-content-description-blockquote-open"
            src={blockquoteOpen}
            alt="Comilla Abierta"
          />
        ) : null}

        {props.descripcion &&
          documentToReactComponents(JSON.parse(props.descripcion?.raw))}
        {props.nombreCategoria !== "Empresas" ? (
          <img
            className="a-content-description-blockquote-close"
            src={blockquoteClose}
            alt="Comilla Cerrada"
          />
        ) : null}
        {props.autoresArticulo && props.nombreCategoria !== "Empresas" ? (
          <span>{props.autoresArticulo[0]}</span>
        ) : null}

        {props.tituloBoton && props.nombreCategoria == "Empresas" ? (
          <div className="a-content-description-container-btns">
            <Button
              type="link"
              text={props.tituloBoton}
              classname={`terciary`}
              gtmMark={`gtmRedDeAmorBanner${normalizeTwoWords(
                props.tituloBoton
              )}BannerPrincipal`}
              href={props?.redireccionBoton}
              isDisabled={false}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ContentDescription;
